import { matchAnyReportingInternalRenderReportUrl, Tracker } from '@futrli/shared-services';
import { createGlobalAnalyticsSnippet } from './segment';

import { SEGMENT_ID, INTERCOM_APP_ID } from './config';
import { store } from './redux-utils/store';

/** Segment.io tracker */
let _tracker: Tracker | undefined;
if (!_tracker) {
  _tracker = new Tracker(SEGMENT_ID, INTERCOM_APP_ID, store);
}

// window.initTracker allows us to init analytics from elsewhere
// (we use this to load analytics only if we have cookie consent)
window.initTracker = () => {
  // don't do anything for internal render report page
  if (!matchAnyReportingInternalRenderReportUrl(window.location.pathname)) {
    createGlobalAnalyticsSnippet();
    _tracker && _tracker.initAnalytics();
  }
};

const tracker = _tracker;
export { tracker };
